"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTitle = exports.StyledModalDefault = void 0;

const styled_components_1 = __importStar(require("styled-components"));

const slideDown = (0, styled_components_1.keyframes)`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
exports.StyledModalDefault = styled_components_1.default.div`
  position: fixed;
  width: ${props => props.width || 'auto'};
  height: ${props => props.height || 'auto'};
  background-color: ${props => props.backgroundColor || props.theme.colors.white};
  box-shadow: 0 3px 6px #00000029;
  margin: 0;
  box-sizing: content-box;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  border: 1px solid ${props => props.theme.colors.gray_302};
  animation: ease-in 0.4s;
  animation-name: ${slideDown};
  z-index: 10001;
`;
exports.StyledTitle = styled_components_1.default.div`
  color: ${props => props.theme.colors.black};
  font-size: ${props => props.theme.fontSizes[18]};
  font-family: Roboto, sans-serif;
  font-weight: 500;
  padding: 19px 0 0 26px;
  height: 24px;
  line-height: ${props => props.theme.lineHeights[24]};
`;